import { useContext } from "react";
import "./App.css";
import Layout from "./Components/Layout/Layout";
import { LangContext } from "./Context/LangContext";

// owl carousel
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


export default function App() {
  const langCtx = useContext(LangContext);

  return (
    <div className={`App ${langCtx === 'ar'  ?  'lang-ar' : 'lang-en'}`}  dir={langCtx ===  "ar" ? "rtl" : "ltr"} >
      <Layout />
    </div>
  );
}
